import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import format from 'date-fns/format';

import { Headline } from 'common/components/Typography';
import { pluralizeWord } from 'common/utils/pluralizeWord';

const ScaledFormsListOptionContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-left: 1rem;
`;

const ScaledFormsListOptionSection = styled.div`
    display: flex;
    flex-direction: column;
`;

const BoldText = styled.span`
    font-weight: bold;
`;

const ON_TEXT = 'on ';
const AND_TEXT = ' and ';
const THEME = 'theme';
const EVENT = 'event';

export const getLastUpdatedLabel = (dateTime) =>
    `Last Updated ${dateTime ? format(new Date(dateTime), 'd MMM, yyyy HH:mm:ss') : ''}`;

export const EventsAndThemes = ({ themeCount, eventCount }) => (
    <p>
        {ON_TEXT}
        <BoldText>
            {themeCount || 0} {pluralizeWord(THEME, parseInt(themeCount, 10))}
        </BoldText>
        {AND_TEXT}
        <BoldText>
            {eventCount || 0} {pluralizeWord(EVENT, parseInt(eventCount, 10))}
        </BoldText>
    </p>
);

EventsAndThemes.propTypes = {
    themeCount: PropTypes.string.isRequired,
    eventCount: PropTypes.string.isRequired,
};

export const truncateName = (name) => (name && name.length >= 51 ? `${name.slice(0, 50)}...` : name);

const ScaledFormsListOption = (props) => {
    const { name, modifiedAtUtc, eventCount, themeCount } = props;

    return (
        <ScaledFormsListOptionContainer>
            <ScaledFormsListOptionSection>
                <Headline size={'small'} tag={'h3'}>
                    {truncateName(name)}
                </Headline>
                {getLastUpdatedLabel(modifiedAtUtc)}
            </ScaledFormsListOptionSection>
            <div>
                <EventsAndThemes themeCount={themeCount} eventCount={eventCount} />
            </div>
        </ScaledFormsListOptionContainer>
    );
};

ScaledFormsListOption.propTypes = {
    name: PropTypes.string.isRequired,
    modifiedAtUtc: PropTypes.string.isRequired,
    eventCount: PropTypes.string.isRequired,
    themeCount: PropTypes.string.isRequired,
};

export default ScaledFormsListOption;
